/**
 * Created by root on 4/10/19.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import TLSearchResults from './../popup/timeLinePeopleTeamSearchResultsView.js';
import CopyOKR from './../okr/copyOKR.js';
import { WbEventHandlerMixins } from './../../utils/common';

const renderSearchResults = function(data, viewId){
    ReactDOM.render(<TLSearchResults data={data}/>, document.getElementById(viewId));
};

const renderCopyOKRDialog = function(data, viewId) {
    ReactDOM.render(<CopyOKR data={data} />, document.getElementById(viewId));
};

const unmountCopyOKRDialog = function(data, viewId) {
    ReactDOM.unmountComponentAtNode(document.getElementById(viewId));
    if (data) {
        WbEventHandlerMixins.editGoal(data);
    }
};

window.renderSearchResults = renderSearchResults;
window.renderCopyOKRDialog = renderCopyOKRDialog;
window.unmountCopyOKRDialog = unmountCopyOKRDialog;
